import React from "react";
import CommonBanner from "../../components/CommonBanner/CommonBanner";
import { Row, Col, Container } from "react-bootstrap";
import AIStack from "../../assets/images/Edge AI Stack - Apis Chain.png";
import "./EdgeStack.css";
// EdgeStack component for rendering the Edge AI Stack description
const EdgeStack = () => {
  // Stack description data with labels and paragraphs for each section
  const stackDescription = [
    {
      // Edge AI Super Apps
      label: "Edge AI Super Apps",
      para: "Apischain provides various Edge AI Super Apps for its partners, including a shared partner Edge AI Super Apps, along with dedicated portals for consumers, solutions, and sites. These Edge AI Super Apps help streamline collaboration and improve access to specific resources for each group.",
    },

    {
      // AgriAnalytics
      label: "AgriAnalytics",
      para: `The AgriAnalytics use case focuses on
          leveraging devices, Digital Twin-1, and Digital Twin-2
          technologies to create a more complete and effective solution. By
          integrating the device data management capabilities of Digital
          Twin-1 with the real-time, industry-specific data handling of
          Digital Twin-2, it provides a comprehensive approach to optimize
          device performance, improve decision-making, and address the
          unique needs of different industry verticals.`,
    },
    {
      // AgriDataHub
      label: "AgriDataHub",
      para: `AgriDataHub
            focuses on the real-time management of live data from devices,
            tailored to specific industry verticals. This solution ensures
            that data is captured, processed, and utilized according to the
            unique needs and requirements of each industry, providing targeted
            insights and improving operational efficiency.`,
    },

    {
      // AgriDeviceHub
      label: "AgriDeviceHub",
      para: `AgriDeviceHub is a comprehensive solution designed to manage the data of devices, including their types, models, and specifications. It provides a structured
          platform to store, organize, and access detailed device
          information, ensuring seamless management and integration of
          device-related data.`,
    },
  ];

  return (
    <>
      {/* CommonBanner component displays the banner with the provided text */}
      <CommonBanner bannerText="Edge AI Stack" />
      
      {/* Container for the main content */}
      <Container className="edge-stack-container section-container">
        <Row className="align-items-center">
          
          {/* Left column for image */}
          <Col md={4}>
            {/* Image related to the Edge AI Stack */}
            <img src={AIStack} alt="Edge AI Stack" />
          </Col>

          {/* Right column for displaying stack description */}
          <Col md={8}>
            {/* Loop through each item in stackDescription and display its label and paragraph */}
            {stackDescription.map((para) => {
              return (
                <p key={para.label}> 
                  <b>{para.label}: </b> 
                  {para.para} 
                </p>
              );
            })}
          </Col>
        </Row>
      </Container>
    </>
  );
};


export default EdgeStack;
